import { render, staticRenderFns } from "./ActiveCode.vue?vue&type=template&id=a4068868&"
import script from "./ActiveCode.vue?vue&type=script&lang=js&"
export * from "./ActiveCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports